import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, tap, filter, catchError, mergeMap } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { BASE_URL } from '../../config/config';
import { NgxSpinnerService } from "ngx-spinner";
import {AuthService} from './../../login/auth.service';
import {Router} from '@angular/router';

@Injectable()

export class MasterService {

    public BASE = BASE_URL.URL;
    private options = { headers: new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8') };
    private userId: any;
    private token: any;

    constructor(private http: HttpClient, private spinnerService: NgxSpinnerService, private authService: AuthService, private route: Router) { }

  // tslint:disable-next-line:no-shadowed-variable
    getIndex(indexUrl, filter = {}) { 
      this.spinnerService.show();
      // @ts-ignore
      return this.http.post(this.BASE + indexUrl , filter)
            .pipe(map(res => res), tap(err => this.spinnerService.hide(), () => this.spinnerService.hide()), catchError(this.handleError.bind(this)));//this.spinnerService.hide();
    }

    // tslint:disable-next-line:no-shadowed-variable
    getIndexGet(getUrl) {
      this.spinnerService.show();
      let token = localStorage.getItem('token');
      // @ts-ignore
      return this.http.get(this.BASE + getUrl, {
        headers: {
          'Authorization': 'Bearer ' + token
        }
      })
            .pipe(map(res => res), tap(err => this.spinnerService.hide(), () => this.spinnerService.hide()), catchError(this.handleError.bind(this)));
    }

    getData(dataUrl) {
      this.spinnerService.show();
      const param = {
        token: localStorage.getItem('token')
      };
      return this.http.post(this.BASE + dataUrl, param)
            .pipe(map(res => res), tap(err => this.spinnerService.hide(), () => this.spinnerService.hide()), catchError(this.handleError.bind(this)));
    }

  // tslint:disable-next-line:variable-name
    getRecordById(id, enc_id, getUrl) {
      this.spinnerService.show();
      const param = {
        token: localStorage.getItem('token'),
        id,
        enc_id
      };
      return this.http.post(this.BASE + getUrl, param)
            .pipe(map(res => res), tap(err => this.spinnerService.hide(), () => this.spinnerService.hide()), catchError(this.handleError.bind(this)));
    }

    addEditRecord(data, postUrl) {
      this.spinnerService.show();
      return this.http.post(this.BASE + postUrl, data)
            .pipe(map(res => res), tap(err => this.spinnerService.hide(), () => this.spinnerService.hide()), catchError(this.handleError.bind(this)));
    }

    deleteRecord(id, encId, deleteUrl) {
      this.spinnerService.show();
      const param = {
        token: localStorage.getItem('token'),
        id,
        enc_id: encId
      };
      return this.http.post(this.BASE + deleteUrl, param)
            .pipe(map(res => res), tap(err => this.spinnerService.hide(), () => this.spinnerService.hide()), catchError(this.handleError.bind(this)));
    }

    fileUpload(data, uploadUrl, headers) {    
      this.spinnerService.show();
      data.append('token', localStorage.getItem('token')); 
      return this.http.post(this.BASE + uploadUrl, data, {
        headers: headers
        }).pipe(map(res => res), tap(err => this.spinnerService.hide(), () => this.spinnerService.hide()), catchError(this.handleError.bind(this)));
    }

    public async downloadFiles(data): Promise<void> {  
        this.spinnerService.show();  
        let token = localStorage.getItem('token');
        let url = data;
        const response = await this.http.get(
          url,
          { observe: 'response' }
        ).toPromise();

        let finalUrl = url;
        if (url.includes('?')) {
         finalUrl += `&token=${token}`;
        } else {
         finalUrl += `?token=${token}`;
        }
        const link = document.createElement('a');
        document.body.appendChild(link);
        link.href = finalUrl;
        link.setAttribute('type', 'hidden');
        link.click();
        this.spinnerService.hide()   
      }
    
    private handleError(error: any){
      if (error.status === 401) {
        localStorage.clear();
        this.route.navigateByUrl(`/login?redirect_link=${this.route.url}`);
        this.spinnerService.hide();
        return
      }
  
      console.error('server error:', error);
      
      // if (error.error instanceof Error) {
      //   const errMessage = error.error.message;
      //   return Observable.throw(errMessage);
      //   // Use the following instead if using lite-server
      //   // return Observable.throw(err.text() || 'backend server error');
      // }
      // return Observable.throw(error || 'Node.js server error');
    }

}
